import { makeAutoObservable, makeObservable, observable } from "mobx";
import { Product } from "../models/product";
import { BaseStore } from "./baseStore";
import firebaseAgent from "../api/firebaseagent";
import { RootStore } from "./rootStore";

export default class SearchStore extends BaseStore<Product> {
    query: string = "";    
    // suggestions: Product[] = [];
    // showSuggestions: boolean = false;

    constructor(rootStore: RootStore) {        
        super(rootStore);        
        makeObservable(this,{
            query:observable
        });
    }

    setQuery = (val: string, allProducts: Product[]) => {
        this.query = val;
        if (val.trim().length > 1) { // Min length to show suggestions
            this.items = allProducts.filter(p =>
                p.title.toLowerCase().includes(val.toLowerCase())
            ).slice(0, 5); // Limit suggestions to top 5
            this.isLoaded = true;
        } else {
            this.items = [];
            this.isLoaded = false;
        }
    };

    // Link this store to the specific service in firebaseAgent
    protected getService() {
        // We use the specific service logic defined in the refactored Agent
        return firebaseAgent.productService; 
    }

    selectSuggestion = (product: Product) => {
        this.query = product.title;
        this.selectedItem = product;
        this.isLoaded = false;
    };

    clearSearch = () => {
        this.query = "";
        this.items = [];
        this.isLoaded = false;
        this.selectedItem = null;
    };
}